// Table Header Fields
export const proformaHeaderFields = [
  "Proforma ID",
  "Proforma Name",
  "Scenario Name",
  "Adjusted Gross Income",
  "Loss Limitation",
  "Contact Group",
  "Federal Revenue Spread",
  "State",
  "Federal Marginal Tax Rate",
  "Internal Markup %",
  "Affiliate Markup %",
  "Total Markup %",
  "Client Name",
  "ITC % Target",
  "Proforma GDrive",
  "Affiliate Markup % EC",
  "Prepayment Income",
  "Federal Tax Credit Amount",
  "ITC / EC Ratio"
];

export const AdminRole = {
  ADMIN: "ADMIN",
  SUBADMIN: "SUBADMIN",
  UNDERWRITER: "UNDERWRITER",
  THRIVE_PARTNER: "THRIVEPARTNER"
}

export const Modules = {
  ASSET_V2: "ASSETV2",
  UNDERWRITER: "UNDERWRITER",
  ASSET_AUDIT: "ASSETAUDIT",
};
